<template>
  <div>
    <el-form :inline="true" ref="form" size="mini" label-width="150px">
      <el-form-item :label="$t('dayinmobanmingcheng')" required>
        <el-select @change="change" v-model="printTemplateId" placeholder="请选择">
          <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name"
                     :value="printTemplate.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shuliang')" required>
        <el-input-number @change="packageNumberChange" v-model="printObj.packageNumber" :min="1" step-strictly
                         :max="printObj.planQuantity - (printObj.printedQuantity ? printObj.printedQuantity : 0)"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('zuoyeyuan')" required>
        <el-input v-model="printObj.customOperator" @change="customOperatorChange"></el-input>
      </el-form-item>
      <el-form-item :label="$t('banbie')" required>
        <el-input v-model="printObj.customShift" @change="customShiftChange"></el-input>
      </el-form-item>
      <el-form-item :label="$t('jihuashuliang')">
        <el-input v-model="printObj.planQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('yidayinshuliang')">
        <el-input v-model="printObj.printedQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('shengyudayinshuliang')">
        <el-input v-model="printObj.printableQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('dayinzhangshu')">
        <el-input-number :min="1" :max="maxCount?maxCount:50" step-strictly v-model="printCount"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('lianxudayinliangzhang')">
        <el-checkbox v-model="isDoublePrint"></el-checkbox>
      </el-form-item>
    </el-form>
    <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :scale="4" :printDatas="printDatas"
                      ref="yiPrintPreview" @finishPrint="finishPrint" @failedPrint="failedPrint"></yi_print_preview>
    <div style="text-align: center;padding: 20px 0;">
      <el-button :loading="printLoading" @click="$emit('closeDialog')" style="width: 130px;">
        {{$t('quxiao')}}
      </el-button>
      <el-button :loading="printLoading" type="primary" @click="print" style="width: 130px;">
        {{printLoading?$t('dayinzhong'):$t('dayin')}}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      printDatas: [],
      printLoading: false,
      printTemplateList: [],
      printTemplateId: null,
      packageRuleList: [],
      defaultPackageRuleId: null,
      printCount: null,
      printData: {},
      printRecordList: [],
      printObj: null,
      maxCount: 50,
      isDoublePrint: false,
    };
  },
  created() {
    this.$set(this, 'printObj', this.$attrs.printObj);
    this.defaultPackageRuleId = null;
    //获取标签内容
    this.http.post('/web/print/record/getStandardPrintInformation', {
      woId: this.printObj.id,
      labelType: 11
    }).then(res => {
      this.$set(this.printObj, 'currentOrder', res.data.currentOrder);
      this.$set(this.printObj, 'printedQuantity', res.data.printedQuantity);
      this.$set(this.printObj, 'batchNo', res.data.printData.productionBatchNumber);
      this.$set(this, 'printData', res.data.printData);
      if (!this.printObj.printedQuantity) {
        this.printObj.printedQuantity = 0;
      }
      this.printObj.printableQuantity = this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0);
    }).catch(err => {
      this.$message.error(err);
    });
    //获取打印模板列表
    this.http.post('/web/print/template/listPrintTemplate', this.$attrs.printObj).then(res => {
      let itemList = res.data;
      this.printTemplateList = itemList;
      if (this.printTemplateList.length > 0) {
        setTimeout(() => {
          this.$set(this, 'printTemplateId', this.printTemplateList[0].id);
          this.$set(this.printData,"customOperator", this.printObj.customOperator);
          this.$set(this.printData,"customShift", this.printObj.customShift);
          this.printDatas = [];
          this.printDatas.push(this.printData);
        }, 800);
      }
    });
    //获取系统管理-生产配置【单次打印标签张数】
    this.http.get('/web/production/config/list?type=15').then(res => {
      if (res.data && res.data.length === 1 && res.data[0].status) {
        this.maxCount = res.data[0].overValue;
      } else {
        this.maxCount = 50;
      }
    }).catch(err => {
      this.$message.error(this.$t(err));
    });
  },
  methods: {
    print() {
      if (!this.printTemplateId) {
        this.$message.error(this.$t('qingxuanzedayinmoban'));
        return;
      }
      if (!this.printObj.packageNumber) {
        this.$message.error(this.$t('shuliang') + this.$t('不能为空'));
        return;
      }
      this.printObj.businessType = 11;
      this.printObj.woNo = this.printObj.no;
      this.printObj.woId = this.printObj.id;
      this.printLoading = true;
      //获取批量打印的标签号
      this.http.post('/custom/litenghui/print/record/getStandardBatchPrintInformation', {
        woId: this.printObj.id,
        printCount: this.printCount,
        packageNumber: this.printObj.packageNumber,
        customOperator:this.printObj.customOperator,
        customShift:this.printObj.customShift,
      }).then(res => {
        this.printDatas = [];
        this.printRecordList = [];
        for (let item of res.data) {
          let print = this.utils.copy(this.printObj);
          print.currentOrder = item.currentOrder;
          print.labelBarcodeNumber = item.labelBarcodeNumber;
          print.templateId = this.printTemplateId;
          print.createBy = null;
          print.createTime = null;
          print.updateBy = null;
          print.updateTime = null;
          this.printRecordList.push(print);
          let printDataTemp = this.utils.copy(this.printData);
          printDataTemp.labelBarcodeNumber = item.labelBarcodeNumber;
          printDataTemp.cartonNumber = item.labelBarcodeNumber;//维尔箱号=条码号
          printDataTemp.cartonQuantity = item.currentOrder;
          printDataTemp.customOperator = item.printData.customOperator;
          printDataTemp.customShift = item.printData.customShift;
          this.printDatas.push(printDataTemp);
          if(this.isDoublePrint){
            this.printDatas.push(printDataTemp);
          }
        }
        setTimeout(() => {
          // 新增批量打印记录
          this.http.post('/web/print/record/batchCreatePrintRecord', this.printRecordList).then(res => {
            this.$message.success(this.$t('chenggong'));
            this.$emit('closeDialog');
            this.printLoading = false;
            this.isDoublePrint = false;
            this.$refs.yiPrintPreview.print2();
          }).catch(err => {
            this.$message.error(err);
          }).finally(() => {
          });
        }, 500);
      }).catch(err => {
        this.printLoading = false;
        this.$message.error(err);
      });
    },
    finishPrint() {
    },
    failedPrint(){
      this.printLoading = false;
    },
    change() {
      this.printDatas = [];
      this.$set(this.printData,"customOperator", this.printObj.customOperator);
      this.$set(this.printData,"customShift", this.printObj.customShift);
      this.printDatas.push(this.printData);
    },
    customOperatorChange(){
      if(this.printObj.customOperator.length>100){
        this.$message.error(this.$t('zuoyeyuan')+this.$t('changduzuidawei')+'100');
        return;
      }
      this.$set(this.printData,"customOperator", this.printObj.customOperator);
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    customShiftChange(){
      if(this.printObj.customShift.length>100){
        this.$message.error(this.$t('banbie')+this.$t('changduzuidawei')+'100');
        return;
      }
      this.$set(this.printData,"customShift", this.printObj.customShift);
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    packageNumberChange() {
      this.printData.quantity = this.printObj.packageNumber;
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
  },
}
</script>

<style scoped lang="scss">

</style>